function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#C68632",
  d: "M15 4h5v7h-5zm13 0h5v7h-5zm12 34.001c0 5-5 4.999-5 4.999s-5 .999-11 1-11-1-11-1-5 .001-5-4.999S11 15 12 13s2-2 2-2h20s1 0 2 2 4 20.001 4 25.001z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#995F1A",
  d: "M35 19a2 2 0 01-2 2H15a2 2 0 01-2-2v-9h22v9zM24 44c3.349 0 6.694-.312 9-.587V31a2 2 0 00-2-2H17a2 2 0 00-2 2v12.331c2.003.292 5.31.669 9 .669zm17-4c0 2-3 3-6 3V31a2 2 0 012-2l2 .001c1.104 0 2 8.999 2 10.999zM7 40c0 2 3 3 6 3V31a2 2 0 00-2-2l-2 .001C7.896 29.001 7 38 7 40z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFC107",
  d: "M24.223 34h-.445c-.982 0-1.778.896-1.778 2v1c0 1.104.796 2 1.777 2h.445c.982 0 1.778-.896 1.778-2v-1c0-1.104-.796-2-1.777-2zm-6-16h-.445c-.982 0-1.778.896-1.778 2v1c0 1.104.796 2 1.777 2h.445c.982 0 1.778-.896 1.778-2v-1c0-1.104-.796-2-1.777-2zm12 0h-.445c-.982 0-1.778.896-1.778 2v1c0 1.104.796 2 1.777 2h.445c.982 0 1.778-.896 1.778-2v-1c0-1.104-.796-2-1.777-2z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#56300D",
  d: "M23.777 34h.445c.28 0 .542.079.777.209V29h-2v5.209c.237-.13.498-.209.778-.209zM23 36h2v5h-2zm-5.223-18h.445c.28 0 .542.08.777.209V10h-2v8.209c.237-.129.498-.209.778-.209zm12 0h.445c.28 0 .542.08.777.209V10h-2v8.209c.236-.129.498-.209.778-.209zM17 20h2v5h-2zm12 0h2v5h-2zm-8-10v-.309C21 8.892 22.232 8 24 8s3 .892 3 1.691V10h2v-.309C29 7.621 26.804 6 24 6s-5 1.621-5 3.691V10h2z"
});

var Svg26Backpack = function Svg26Backpack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    width: 96,
    height: 96,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg26Backpack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/26-backpack.fe6d9e90.svg";
export { ForwardRef as ReactComponent };